/* unplugin-vue-components disabled */import { render } from "./header.vue?vue&type=template&id=61ab6cb2&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=61ab6cb2&scoped=true&lang=less"

import exportComponent from "/Users/yfy/work/work/cms-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ab6cb2"]])

export default __exports__